import {COVERGO_CA_UAT, COVERGO_SAAS_DEV, COVERGO_ASIA_QA, COVERGO_CA_PROD} from "../consts.js"

export const gms_dev = {
	"gms-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "gms_dev",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV
	}
}

export const gms_uat = {
	"gms-studio.uat.ca.covergo.cloud": {
		appConfig: {
			tenantId: "gms",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_UAT,
		fileSystem: {
			bucketName: "covergo-cace1-uat-gms-uat"
		}
	},
}

export const gms_sandbox = {
	"gms-sandbox-studio.uat.ca.covergo.cloud": {
		appConfig: {
			tenantId: "gms_sandbox",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_UAT,
		fileSystem: {
			bucketName: "covergo-cace1-uat-gms-sandbox-uat"
		}
	},
}

export const gms_migration = {
	"gms-migration-studio.uat.ca.covergo.cloud": {
		appConfig: {
			tenantId: "gms_migration",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_UAT,
		fileSystem: {
			bucketName: "covergo-cace1-uat-gms-migration-uat"
		}
	},
}

export const gms_training = {
	"gms-training-studio.uat.ca.covergo.cloud": {
		appConfig: {
			tenantId: "gms_training",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_UAT,
		fileSystem: {
			bucketName: "covergo-cace1-uat-gms-training-uat"
		}
	},
}


export const gms_qa = {
	"gms-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "gms_qa",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_ASIA_QA,
		fileSystem: {
			bucketName: "covergo-apse1-qa-gms-qa"
		}
	},
}

export const gms_prod = {
	"gms-studio.ca.covergo.com": {
		appConfig: {
			tenantId: "gms_prod",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_PROD,
		fileSystem: {
			bucketName: "covergo-cace1-prod-gms"
		}
	},
}

